/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityVulnerabilitySummaryMonthResponse {
    getFixupPrototypeFunction() { return SecurityVulnerabilitySummaryMonthResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityVulnerabilitySummaryMonthResponse>): SecurityVulnerabilitySummaryMonthResponse {
        let obj = Object.assign(new SecurityVulnerabilitySummaryMonthResponse(), model);
        SecurityVulnerabilitySummaryMonthResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityVulnerabilitySummaryMonthResponse>): SecurityVulnerabilitySummaryMonthResponse {
        if (!model) return null;
        return SecurityVulnerabilitySummaryMonthResponse.newInstance(<SecurityVulnerabilitySummaryMonthResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityVulnerabilitySummaryMonthResponse) {
        if (!obj) return;

        models.SecurityVulnerabilitySummaryMonthResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityVulnerabilitySummaryMonthResponse): boolean {
        Object.setPrototypeOf(obj, SecurityVulnerabilitySummaryMonthResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_month) {
            for (let val of this.summary_by_month) {
                models.SecurityDashboardVulnerabilityMonth.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the vulnerabilities by Month
     */
    summary_by_month: Array<models.SecurityDashboardVulnerabilityMonth>;

}
